import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UserManagementComponent } from './user-management.component';
import { RegisterComponent } from './register/register.component';
import { importExpr } from '@angular/compiler/src/output/output_ast';
import { AuthGuard } from '../../shared/auth.guard';
import { MunicipalPoliceGuard } from '../../shared/municipal-police.guard';

const routes: Routes = [
  {
    path: '',
    component: UserManagementComponent,
    canActivate: [AuthGuard, MunicipalPoliceGuard],
    data: {
      breadcrumb: 'Users Management'
    },
    children: [
      {
        path: '',
        data: { breadcrumb: '' },
        loadChildren: () => import('./register/register.module').then(m => m.RegisterModule)
      },
      {
        path: '',
        data: { breadcrumb: '' },
        loadChildren: () => import('./all-users/all-users.module').then(m => m.AllUsersModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserManagementRoutingModule { }
